import { useFetchUser } from '@/features/authorization/api/useFetchUser'
import { formatNumber } from '@/utils'
import { Trans } from '@lingui/react/macro'
import { useLeaderboard, useLeaderboardRanking } from '../api'

export const LeaderboardStatsPanel = () => {
  const { data, isFetched } = useLeaderboardRanking()
  const { data: user } = useFetchUser(true)
  const { data: leaderboard, isFetched: isLeaderboardFetched } = useLeaderboard({ page: 1, limit: 1 })

  // Truncate like the leaderboard's `Math.trunc(Number(score))`; formatNumber alone rounds.
  const myPoints = formatNumber(Math.trunc(Number(user?.points ?? 0)), 0)
  const avgPoints = isLeaderboardFetched && leaderboard?.avg ? formatNumber(leaderboard.avg, 0) : '-'

  const myRank = isFetched && data?.rank ? (data.rank.includes('+') ? data.rank : formatNumber(data.rank, 0)) : '-'

  return (
    <div className="max-tablet:pr-0 max-mobile:w-[unset] w-[270px] pr-10">
      <div className="text-subtitle font-semibold">
        <Trans>Leaderboard</Trans>
      </div>
      <div className="mt-5 flex flex-col gap-4">
        <div className="flex flex-col border-b border-solid border-gray-100 pb-4">
          <div className="text-gray-90">
            <Trans>My rank</Trans>
          </div>
          <div className="text-h2 text-orange">{myRank}</div>
        </div>
        <div className="flex flex-col gap-1 border-b border-solid border-gray-100 pb-4">
          <div className="text-gray-90">
            <Trans>My points</Trans>
          </div>
          <div>{myPoints}</div>
        </div>
        <div className="flex flex-col gap-1 pb-4">
          <div className="text-gray-90">
            <Trans>Avg. points</Trans>
          </div>
          <div>{avgPoints}</div>
        </div>
      </div>
    </div>
  )
}
